import { render } from "./TakeBackPopup.vue?vue&type=template&id=5f38da6f&scoped=true"
import script from "./TakeBackPopup.vue?vue&type=script&lang=js"
export * from "./TakeBackPopup.vue?vue&type=script&lang=js"

import "./TakeBackPopup.vue?vue&type=style&index=0&id=5f38da6f&lang=scss&scoped=true"

import exportComponent from "/Users/flegate/Serveur/Sites/welcom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f38da6f"]])

export default __exports__